import { INR, USD } from "features/Listings/Listings.constants";

export const OFFER_TARGET_TYPE = {
  SPECIFIC_OFFERING: 1,
  SPECIFIC_PAYMENT_PAGE: 2,
  ALL_OFFERINGS: 3,
};

export const OFFER_TARGET_TYPE_OPTIONS = [
  {
    label: "Universal Offer - Applies to all Payment & Offering Pages",
    value: OFFER_TARGET_TYPE.ALL_OFFERINGS,
  },
  {
    label: "Specific Offering",
    value: OFFER_TARGET_TYPE.SPECIFIC_OFFERING,
  },
  {
    label: "Specific Payment Page",
    value: OFFER_TARGET_TYPE.SPECIFIC_PAYMENT_PAGE,
  },
];

export const OFFER_TYPE = {
  AMOUNT: 1,
  PERCENTAGE: 2,
};

export const OFFER_TYPE_OPTIONS = [
  { label: "Amount", value: OFFER_TYPE.AMOUNT },
  { label: "Percentage", value: OFFER_TYPE.PERCENTAGE },
];

export const TIMER_TYPE = {
  FIXED: 1,
  EVERGREEN: 2,
};

export const TIMER_TYPE_OPTIONS = [
  { label: "Fixed", value: TIMER_TYPE.FIXED },
  { label: "Evergreen", value: TIMER_TYPE.EVERGREEN },
];

export const DURATION_UNITS = [
  { label: "Minutes", value: "minutes" },
  { label: "Hours", value: "hours" },
  { label: "Days", value: "days" },
];

export const DURATION_UNIT_MULTIPLIERS = {
  seconds: 1 / 3600,
  minutes: 1 / 60,
  hours: 1,
  days: 24,
};

/** Unit enums for the two independent unit choices (§5.1) + time offsets. */
export const THRESHOLD_UNIT = {
  PERCENT: "percent",
  COUNT: "count",
};

export const VALUE_UNIT = {
  PERCENT: "percent",
  FLAT: "flat",
};

export const TIME_UNIT = {
  DAYS: "days",
  HOURS: "hours",
};

/** Evergreen "starts counting from" options (§4.2). */
export const EVERGREEN_START_EVENT = {
  PAGE_VIEW: "page_view",
  WAITLIST: "waitlist",
  SIGNUP: "signup",
};

/** VIP / Priority Slots "apply by" mode (§5.3). */
export const VIP_APPLY_BY = {
  WEEKDAY: "weekday",
  DATE: "date",
};

/** Fallback row key for Batch Wise "All future batches (default)" (§5.3). */
export const BATCH_FUTURE_UID = "__future__";

/** Defaults reused across the form, builders and payload/prefill. */
export const DEFAULT_THRESHOLD_UNIT = THRESHOLD_UNIT.PERCENT;
export const DEFAULT_VALUE_UNIT = VALUE_UNIT.PERCENT;
export const DEFAULT_TIME_THRESHOLD_UNIT = TIME_UNIT.DAYS;
export const DEFAULT_EVERGREEN_DURATION_VALUE = 24;
export const DEFAULT_EVERGREEN_DURATION_UNIT = TIME_UNIT.HOURS;
export const DEFAULT_EVERGREEN_START_EVENT = EVERGREEN_START_EVENT.PAGE_VIEW;
export const DEFAULT_VIP_APPLY_BY = VIP_APPLY_BY.WEEKDAY;

/** Step-0 chooser deep-link query flag (Sales & Marketing tile → list page). */
export const NEW_OFFER_QUERY_PARAM = "new";

export const LTO_FORM_KEYS = {
  TARGET_TYPE: "target_type",
  COMBO_PAGES: "combo_pages",
  DYNAMIC_LINK_UUID: "dynamic_link_uuid",
  LISTINGS: "listings",
  DYNAMIC_LINK_UUIDS: "dynamic_link_uuids",
  OFFER_TYPE: "offer_type",
  TIMER_TYPE: "timer_type",
  // Unified Early Bird + Surge keys (frontend-only until backend ships contract).
  // Kept in form state; sent inside `metadata` so current backend ignores them.
  DIRECTION: "direction",
  TRIGGER_TYPE: "trigger_type",
  TIERS: "tiers",
  THRESHOLD_UNIT: "threshold_unit",
  VALUE_UNIT: "value_unit",
  SHOW_AT_CHECKOUT: "show_at_checkout",
  SYNC_END_TO_START: "sync_end_to_start",
  EVERGREEN_START_EVENT: "evergreen_start_event",
  VIP_APPLY_BY: "vip_apply_by",
  VIP_WINDOWS: "vip_windows",
  VIP_START_DATE: "vip_start_date",
  VIP_END_DATE: "vip_end_date",
  BATCH_VALUES: "batch_values",
  EVERGREEN_DURATION_SECONDS: "evergreen_duration_seconds",
  EVERGREEN_DURATION_VALUE: "evergreen_duration_value",
  EVERGREEN_DURATION_UNIT: "evergreen_duration_unit",
  PERCENTAGE_VALUE: "percentage_value",
  INR_PRICE: "INRPrice",
  USD_CHECKBOX: "USD",
  USD_PRICE: "USDPrice",
};

export const LTO_EDIT_SESSION_KEY = "editData";

/**
 * Array-level validation errors are stored under these NON-conflicting keys,
 * never under the row array path itself. final-form's processErrors writes each
 * registered field with `setIn(errors, name, value)`; a scalar at `tiers` while
 * nested `tiers[0].x` fields exist throws "Cannot set a numeric property on an
 * object". A dedicated `*_error` key has no nested siblings and is always safe.
 */
export const ARRAY_ERROR_KEYS = {
  TIERS: "tiers_error",
  VIP: "vip_windows_error",
  BATCH: "batch_values_error",
};


export const LTO_SUPPORTED_CURRENCIES = [INR, USD];

export const ONE_HOUR_IN_SECONDS = 3600;
